import * as React from "react";

const BarGraphBlank = (props) => (
  <svg
    width="253"
    height="103"
    viewBox="0 0 253 103"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.34306 19.543H1.75157C0.958276 19.543 0.315186 20.1861 0.315186 20.9794C0.315186 21.7726 0.958276 22.4157 1.75157 22.4157H8.34306C9.13635 22.4157 9.77944 21.7726 9.77944 20.9794C9.77944 20.1861 9.13635 19.543 8.34306 19.543Z"
      fill="#E6E6E6"
    />
    <path
      d="M8.42753 39.7383H1.83604C1.04275 39.7383 0.399658 40.3814 0.399658 41.1747C0.399658 41.968 1.04275 42.611 1.83604 42.611H8.42753C9.22083 42.611 9.86392 41.968 9.86392 41.1747C9.86392 40.3814 9.22083 39.7383 8.42753 39.7383Z"
      fill="#E6E6E6"
    />
    <path
      d="M8.51396 59.9336H1.92247C1.12917 59.9336 0.486084 60.5767 0.486084 61.37C0.486084 62.1633 1.12917 62.8064 1.92247 62.8064H8.51396C9.30725 62.8064 9.95034 62.1633 9.95034 61.37C9.95034 60.5767 9.30725 59.9336 8.51396 59.9336Z"
      fill="#E6E6E6"
    />
    <path
      d="M8.59843 80.125H2.00694C1.21365 80.125 0.570557 80.7681 0.570557 81.5614C0.570557 82.3547 1.21365 82.9978 2.00694 82.9978H8.59843C9.39172 82.9978 10.0348 82.3547 10.0348 81.5614C10.0348 80.7681 9.39172 80.125 8.59843 80.125Z"
      fill="#E6E6E6"
    />
    <g opacity="0.2">
      <path
        d="M12.4635 20.9258H9.77881V21.0378H12.4635V20.9258Z"
        fill="#F2F2F2"
      />
      <path
        d="M244.72 21.0378H239.445V20.9258H244.72V21.0378ZM234.164 21.0378H228.888V20.9258H234.164L234.164 21.0378ZM223.608 21.0378H218.328V20.9258H223.608V21.0378ZM213.052 21.0378H207.772V20.9258H213.052V21.0378ZM202.496 21.0378H197.216V20.9258H202.496L202.496 21.0378ZM191.936 21.0378H186.66V20.9258H191.935L191.936 21.0378ZM181.38 21.0378H176.099V20.9258H181.38V21.0378ZM170.824 21.0378H165.544V20.9258H170.824V21.0378ZM160.268 21.0378H154.988V20.9258H160.268V21.0378ZM149.707 21.0378H144.431V20.9258H149.706L149.707 21.0378ZM139.151 21.0378H133.871V20.9258H139.151V21.0378ZM128.595 21.0378H123.315V20.9258H128.595V21.0378ZM118.039 21.0378H112.759V20.9258H118.039V21.0378ZM107.479 21.0378H102.202V20.9258H107.477L107.479 21.0378ZM96.9227 21.0378H91.6457V20.9258H96.9214L96.9227 21.0378ZM86.3667 21.0378H81.1033V20.9258H86.3837L86.3667 21.0378ZM75.8107 21.0378H70.5304V20.9258H75.8107V21.0378ZM65.2501 21.0378H59.974V20.9258H65.2496L65.2501 21.0378ZM54.6941 21.0378H49.4167V20.9258H54.7013L54.6941 21.0378ZM44.1381 21.0378H38.8578V20.9258H44.1381V21.0378ZM33.5821 21.0378H28.3018V20.9258H33.5821V21.0378ZM23.0215 21.0378H17.7441V20.9258H23.0198L23.0215 21.0378Z"
        fill="#F2F2F2"
      />
      <path d="M252.685 20.9258H250V21.0378H252.685V20.9258Z" fill="#F2F2F2" />
      <path
        d="M12.4635 20.9258H9.77881V21.0378H12.4635V20.9258Z"
        fill="#F2F2F2"
      />
      <path
        d="M244.72 21.0378H239.445V20.9258H244.72V21.0378ZM234.164 21.0378H228.888V20.9258H234.164L234.164 21.0378ZM223.608 21.0378H218.328V20.9258H223.608V21.0378ZM213.052 21.0378H207.772V20.9258H213.052V21.0378ZM202.496 21.0378H197.216V20.9258H202.496L202.496 21.0378ZM191.936 21.0378H186.66V20.9258H191.935L191.936 21.0378ZM181.38 21.0378H176.099V20.9258H181.38V21.0378ZM170.824 21.0378H165.544V20.9258H170.824V21.0378ZM160.268 21.0378H154.988V20.9258H160.268V21.0378ZM149.707 21.0378H144.431V20.9258H149.706L149.707 21.0378ZM139.151 21.0378H133.871V20.9258H139.151V21.0378ZM128.595 21.0378H123.315V20.9258H128.595V21.0378ZM118.039 21.0378H112.759V20.9258H118.039V21.0378ZM107.479 21.0378H102.202V20.9258H107.477L107.479 21.0378ZM96.9227 21.0378H91.6457V20.9258H96.9214L96.9227 21.0378ZM86.3667 21.0378H81.1033V20.9258H86.3837L86.3667 21.0378ZM75.8107 21.0378H70.5304V20.9258H75.8107V21.0378ZM65.2501 21.0378H59.974V20.9258H65.2496L65.2501 21.0378ZM54.6941 21.0378H49.4167V20.9258H54.7013L54.6941 21.0378ZM44.1381 21.0378H38.8578V20.9258H44.1381V21.0378ZM33.5821 21.0378H28.3018V20.9258H33.5821V21.0378ZM23.0215 21.0378H17.7441V20.9258H23.0198L23.0215 21.0378Z"
        fill="#F2F2F2"
      />
      <path d="M252.685 20.9258H250V21.0378H252.685V20.9258Z" fill="#F2F2F2" />
    </g>
    <g opacity="0.2">
      <path
        d="M12.4635 0.792969H9.77881V0.905027H12.4635V0.792969Z"
        fill="#F2F2F2"
      />
      <path
        d="M244.72 0.90503H239.445V0.792969H244.72V0.90503ZM234.164 0.90503H228.888V0.792969H234.164L234.164 0.90503ZM223.608 0.90503H218.328V0.792969H223.608V0.90503ZM213.052 0.90503H207.772V0.792969H213.052V0.90503ZM202.496 0.90503H197.216V0.792969H202.496L202.496 0.90503ZM191.936 0.90503H186.66V0.792969H191.935L191.936 0.90503ZM181.38 0.90503H176.099V0.792969H181.38V0.90503ZM170.824 0.90503H165.544V0.792969H170.824V0.90503ZM160.268 0.90503H154.988V0.792969H160.268V0.90503ZM149.707 0.90503H144.431V0.792969H149.706L149.707 0.90503ZM139.151 0.90503H133.871V0.792969H139.151V0.90503ZM128.595 0.90503H123.315V0.792969H128.595V0.90503ZM118.039 0.90503H112.759V0.792969H118.039V0.90503ZM107.479 0.90503H102.202V0.792969H107.477L107.479 0.90503ZM96.9227 0.90503H91.6457V0.792969H96.9214L96.9227 0.90503ZM86.3667 0.90503H81.1033V0.792969H86.3837L86.3667 0.90503ZM75.8107 0.90503H70.5304V0.792969H75.8107V0.90503ZM65.2501 0.90503H59.974V0.792969H65.2496L65.2501 0.90503ZM54.6941 0.90503H49.4167V0.792969H54.7013L54.6941 0.90503ZM44.1381 0.90503H38.8578V0.792969H44.1381V0.90503ZM33.5821 0.90503H28.3018V0.792969H33.5821V0.90503ZM23.0215 0.90503H17.7441V0.792969H23.0198L23.0215 0.90503Z"
        fill="#F2F2F2"
      />
      <path
        d="M252.685 0.792969H250V0.905027H252.685V0.792969Z"
        fill="#F2F2F2"
      />
    </g>
    <g opacity="0.2">
      <path
        d="M12.4635 41.0391H9.77881V41.1511H12.4635V41.0391Z"
        fill="#F2F2F2"
      />
      <path
        d="M244.72 41.1472H239.445V41.0352H244.72V41.1472ZM234.164 41.1472H228.888V41.0352H234.164L234.164 41.1472ZM223.608 41.1472H218.328V41.0352H223.608V41.1472ZM213.052 41.1472H207.772V41.0352H213.052V41.1472ZM202.496 41.1472H197.216V41.0352H202.496L202.496 41.1472ZM191.936 41.1472H186.66V41.0352H191.935L191.936 41.1472ZM181.38 41.1472H176.099V41.0352H181.38V41.1472ZM170.824 41.1472H165.544V41.0352H170.824V41.1472ZM160.268 41.1472H154.988V41.0352H160.268V41.1472ZM149.707 41.1472H144.431V41.0352H149.706L149.707 41.1472ZM139.151 41.1472H133.871V41.0352H139.151V41.1472ZM128.595 41.1472H123.315V41.0352H128.595V41.1472ZM118.039 41.1472H112.759V41.0352H118.039V41.1472ZM107.479 41.1472H102.202V41.0352H107.477L107.479 41.1472ZM96.9227 41.1472H91.6457V41.0352H96.9214L96.9227 41.1472ZM86.3667 41.1472H81.1033V41.0352H86.3837L86.3667 41.1472ZM75.8107 41.1472H70.5304V41.0352H75.8107V41.1472ZM65.2501 41.1472H59.974V41.0352H65.2496L65.2501 41.1472ZM54.6941 41.1472H49.4167V41.0352H54.7013L54.6941 41.1472ZM44.1381 41.1472H38.8578V41.0352H44.1381V41.1472ZM33.5821 41.1472H28.3018V41.0352H33.5821V41.1472ZM23.0215 41.1472H17.7441V41.0352H23.0198L23.0215 41.1472Z"
        fill="#F2F2F2"
      />
      <path d="M252.685 41.0391H250V41.1511H252.685V41.0391Z" fill="#F2F2F2" />
      <path
        d="M12.4635 41.0391H9.77881V41.1511H12.4635V41.0391Z"
        fill="#F2F2F2"
      />
      <path
        d="M244.72 41.1472H239.445V41.0352H244.72V41.1472ZM234.164 41.1472H228.888V41.0352H234.164L234.164 41.1472ZM223.608 41.1472H218.328V41.0352H223.608V41.1472ZM213.052 41.1472H207.772V41.0352H213.052V41.1472ZM202.496 41.1472H197.216V41.0352H202.496L202.496 41.1472ZM191.936 41.1472H186.66V41.0352H191.935L191.936 41.1472ZM181.38 41.1472H176.099V41.0352H181.38V41.1472ZM170.824 41.1472H165.544V41.0352H170.824V41.1472ZM160.268 41.1472H154.988V41.0352H160.268V41.1472ZM149.707 41.1472H144.431V41.0352H149.706L149.707 41.1472ZM139.151 41.1472H133.871V41.0352H139.151V41.1472ZM128.595 41.1472H123.315V41.0352H128.595V41.1472ZM118.039 41.1472H112.759V41.0352H118.039V41.1472ZM107.479 41.1472H102.202V41.0352H107.477L107.479 41.1472ZM96.9227 41.1472H91.6457V41.0352H96.9214L96.9227 41.1472ZM86.3667 41.1472H81.1033V41.0352H86.3837L86.3667 41.1472ZM75.8107 41.1472H70.5304V41.0352H75.8107V41.1472ZM65.2501 41.1472H59.974V41.0352H65.2496L65.2501 41.1472ZM54.6941 41.1472H49.4167V41.0352H54.7013L54.6941 41.1472ZM44.1381 41.1472H38.8578V41.0352H44.1381V41.1472ZM33.5821 41.1472H28.3018V41.0352H33.5821V41.1472ZM23.0215 41.1472H17.7441V41.0352H23.0198L23.0215 41.1472Z"
        fill="#F2F2F2"
      />
      <path d="M252.685 41.0391H250V41.1511H252.685V41.0391Z" fill="#F2F2F2" />
    </g>
    <g opacity="0.2">
      <path
        d="M12.4635 61.1406H9.77881V61.2527H12.4635V61.1406Z"
        fill="#F2F2F2"
      />
      <path
        d="M244.72 61.2527H239.445V61.1406H244.72V61.2527ZM234.164 61.2527H228.888V61.1406H234.164L234.164 61.2527ZM223.608 61.2527H218.328V61.1406H223.608V61.2527ZM213.052 61.2527H207.772V61.1406H213.052V61.2527ZM202.496 61.2527H197.216V61.1406H202.496L202.496 61.2527ZM191.936 61.2527H186.66V61.1406H191.935L191.936 61.2527ZM181.38 61.2527H176.099V61.1406H181.38V61.2527ZM170.824 61.2527H165.544V61.1406H170.824V61.2527ZM160.268 61.2527H154.988V61.1406H160.268V61.2527ZM149.707 61.2527H144.431V61.1406H149.706L149.707 61.2527ZM139.151 61.2527H133.871V61.1406H139.151V61.2527ZM128.595 61.2527H123.315V61.1406H128.595V61.2527ZM118.039 61.2527H112.759V61.1406H118.039V61.2527ZM107.479 61.2527H102.202V61.1406H107.477L107.479 61.2527ZM96.9227 61.2527H91.6457V61.1406H96.9214L96.9227 61.2527ZM86.3667 61.2527H81.1033V61.1406H86.3837L86.3667 61.2527ZM75.8107 61.2527H70.5304V61.1406H75.8107V61.2527ZM65.2501 61.2527H59.974V61.1406H65.2496L65.2501 61.2527ZM54.6941 61.2527H49.4167V61.1406H54.7013L54.6941 61.2527ZM44.1381 61.2527H38.8578V61.1406H44.1381V61.2527ZM33.5821 61.2527H28.3018V61.1406H33.5821V61.2527ZM23.0215 61.2527H17.7441V61.1406H23.0198L23.0215 61.2527Z"
        fill="#F2F2F2"
      />
      <path d="M252.685 61.1406H250V61.2527H252.685V61.1406Z" fill="#F2F2F2" />
      <path
        d="M12.4635 61.1406H9.77881V61.2527H12.4635V61.1406Z"
        fill="#F2F2F2"
      />
      <path
        d="M244.72 61.2527H239.445V61.1406H244.72V61.2527ZM234.164 61.2527H228.888V61.1406H234.164L234.164 61.2527ZM223.608 61.2527H218.328V61.1406H223.608V61.2527ZM213.052 61.2527H207.772V61.1406H213.052V61.2527ZM202.496 61.2527H197.216V61.1406H202.496L202.496 61.2527ZM191.936 61.2527H186.66V61.1406H191.935L191.936 61.2527ZM181.38 61.2527H176.099V61.1406H181.38V61.2527ZM170.824 61.2527H165.544V61.1406H170.824V61.2527ZM160.268 61.2527H154.988V61.1406H160.268V61.2527ZM149.707 61.2527H144.431V61.1406H149.706L149.707 61.2527ZM139.151 61.2527H133.871V61.1406H139.151V61.2527ZM128.595 61.2527H123.315V61.1406H128.595V61.2527ZM118.039 61.2527H112.759V61.1406H118.039V61.2527ZM107.479 61.2527H102.202V61.1406H107.477L107.479 61.2527ZM96.9227 61.2527H91.6457V61.1406H96.9214L96.9227 61.2527ZM86.3667 61.2527H81.1033V61.1406H86.3837L86.3667 61.2527ZM75.8107 61.2527H70.5304V61.1406H75.8107V61.2527ZM65.2501 61.2527H59.974V61.1406H65.2496L65.2501 61.2527ZM54.6941 61.2527H49.4167V61.1406H54.7013L54.6941 61.2527ZM44.1381 61.2527H38.8578V61.1406H44.1381V61.2527ZM33.5821 61.2527H28.3018V61.1406H33.5821V61.2527ZM23.0215 61.2527H17.7441V61.1406H23.0198L23.0215 61.2527Z"
        fill="#F2F2F2"
      />
      <path d="M252.685 61.1406H250V61.2527H252.685V61.1406Z" fill="#F2F2F2" />
    </g>
    <g opacity="0.2">
      <path
        d="M12.4635 81.2578H9.77881V81.3699H12.4635V81.2578Z"
        fill="#F2F2F2"
      />
      <path
        d="M244.72 81.3699H239.445V81.2578H244.72V81.3699ZM234.164 81.3699H228.888V81.2578H234.164L234.164 81.3699ZM223.608 81.3699H218.328V81.2578H223.608V81.3699ZM213.052 81.3699H207.772V81.2578H213.052V81.3699ZM202.496 81.3699H197.216V81.2578H202.496L202.496 81.3699ZM191.936 81.3699H186.66V81.2578H191.935L191.936 81.3699ZM181.38 81.3699H176.099V81.2578H181.38V81.3699ZM170.824 81.3699H165.544V81.2578H170.824V81.3699ZM160.268 81.3699H154.988V81.2578H160.268V81.3699ZM149.707 81.3699H144.431V81.2578H149.706L149.707 81.3699ZM139.151 81.3699H133.871V81.2578H139.151V81.3699ZM128.595 81.3699H123.315V81.2578H128.595V81.3699ZM118.039 81.3699H112.759V81.2578H118.039V81.3699ZM107.479 81.3699H102.202V81.2578H107.477L107.479 81.3699ZM96.9227 81.3699H91.6457V81.2578H96.9214L96.9227 81.3699ZM86.3667 81.3699H81.1033V81.2578H86.3837L86.3667 81.3699ZM75.8107 81.3699H70.5304V81.2578H75.8107V81.3699ZM65.2501 81.3699H59.974V81.2578H65.2496L65.2501 81.3699ZM54.6941 81.3699H49.4167V81.2578H54.7013L54.6941 81.3699ZM44.1381 81.3699H38.8578V81.2578H44.1381V81.3699ZM33.5821 81.3699H28.3018V81.2578H33.5821V81.3699ZM23.0215 81.3699H17.7441V81.2578H23.0198L23.0215 81.3699Z"
        fill="#F2F2F2"
      />
      <path d="M252.685 81.2578H250V81.3699H252.685V81.2578Z" fill="#F2F2F2" />
      <path
        d="M12.4635 81.2578H9.77881V81.3699H12.4635V81.2578Z"
        fill="#F2F2F2"
      />
      <path
        d="M244.72 81.3699H239.445V81.2578H244.72V81.3699ZM234.164 81.3699H228.888V81.2578H234.164L234.164 81.3699ZM223.608 81.3699H218.328V81.2578H223.608V81.3699ZM213.052 81.3699H207.772V81.2578H213.052V81.3699ZM202.496 81.3699H197.216V81.2578H202.496L202.496 81.3699ZM191.936 81.3699H186.66V81.2578H191.935L191.936 81.3699ZM181.38 81.3699H176.099V81.2578H181.38V81.3699ZM170.824 81.3699H165.544V81.2578H170.824V81.3699ZM160.268 81.3699H154.988V81.2578H160.268V81.3699ZM149.707 81.3699H144.431V81.2578H149.706L149.707 81.3699ZM139.151 81.3699H133.871V81.2578H139.151V81.3699ZM128.595 81.3699H123.315V81.2578H128.595V81.3699ZM118.039 81.3699H112.759V81.2578H118.039V81.3699ZM107.479 81.3699H102.202V81.2578H107.477L107.479 81.3699ZM96.9227 81.3699H91.6457V81.2578H96.9214L96.9227 81.3699ZM86.3667 81.3699H81.1033V81.2578H86.3837L86.3667 81.3699ZM75.8107 81.3699H70.5304V81.2578H75.8107V81.3699ZM65.2501 81.3699H59.974V81.2578H65.2496L65.2501 81.3699ZM54.6941 81.3699H49.4167V81.2578H54.7013L54.6941 81.3699ZM44.1381 81.3699H38.8578V81.2578H44.1381V81.3699ZM33.5821 81.3699H28.3018V81.2578H33.5821V81.3699ZM23.0215 81.3699H17.7441V81.2578H23.0198L23.0215 81.3699Z"
        fill="#F2F2F2"
      />
      <path d="M252.685 81.2578H250V81.3699H252.685V81.2578Z" fill="#F2F2F2" />
    </g>
    <path
      d="M40.6326 0.929688V81.5616"
      stroke="#F2F2F2"
      stroke-width="0.0424463"
      stroke-miterlimit="10"
    />
    <path
      d="M73.2996 0.929688V81.5616"
      stroke="#F2F2F2"
      stroke-width="0.0424463"
      stroke-miterlimit="10"
    />
    <path
      d="M105.965 0.929688V81.5616"
      stroke="#F2F2F2"
      stroke-width="0.0424463"
      stroke-miterlimit="10"
    />
    <path
      d="M138.632 0.929688V81.5616"
      stroke="#F2F2F2"
      stroke-width="0.0424463"
      stroke-miterlimit="10"
    />
    <path
      d="M171.298 0.929688V81.5616"
      stroke="#F2F2F2"
      stroke-width="0.0424463"
      stroke-miterlimit="10"
    />
    <path
      d="M203.965 0.929688V81.5616"
      stroke="#F2F2F2"
      stroke-width="0.0424463"
      stroke-miterlimit="10"
    />
    <path
      d="M236.63 0.929688V81.5616"
      stroke="#F2F2F2"
      stroke-width="0.0424463"
      stroke-miterlimit="10"
    />
    <path
      d="M40.8123 102.205C42.0479 102.205 43.0496 101.203 43.0496 99.9678C43.0496 98.7322 42.0479 97.7305 40.8123 97.7305C39.5766 97.7305 38.575 98.7322 38.575 99.9678C38.575 101.203 39.5766 102.205 40.8123 102.205Z"
      fill="#E6E6E6"
    />
    <path
      d="M73.4793 102.205C74.7149 102.205 75.7166 101.203 75.7166 99.9678C75.7166 98.7322 74.7149 97.7305 73.4793 97.7305C72.2436 97.7305 71.2419 98.7322 71.2419 99.9678C71.2419 101.203 72.2436 102.205 73.4793 102.205Z"
      fill="#E6E6E6"
    />
    <path
      d="M106.145 102.205C107.38 102.205 108.382 101.203 108.382 99.9678C108.382 98.7322 107.38 97.7305 106.145 97.7305C104.909 97.7305 103.907 98.7322 103.907 99.9678C103.907 101.203 104.909 102.205 106.145 102.205Z"
      fill="#E6E6E6"
    />
    <path
      d="M138.81 102.205C140.046 102.205 141.047 101.203 141.047 99.9678C141.047 98.7322 140.046 97.7305 138.81 97.7305C137.574 97.7305 136.573 98.7322 136.573 99.9678C136.573 101.203 137.574 102.205 138.81 102.205Z"
      fill="#E6E6E6"
    />
    <path
      d="M171.477 102.205C172.713 102.205 173.715 101.203 173.715 99.9678C173.715 98.7322 172.713 97.7305 171.477 97.7305C170.242 97.7305 169.24 98.7322 169.24 99.9678C169.24 101.203 170.242 102.205 171.477 102.205Z"
      fill="#E6E6E6"
    />
    <path
      d="M204.143 102.205C205.378 102.205 206.38 101.203 206.38 99.9678C206.38 98.7322 205.378 97.7305 204.143 97.7305C202.907 97.7305 201.905 98.7322 201.905 99.9678C201.905 101.203 202.907 102.205 204.143 102.205Z"
      fill="#E6E6E6"
    />
    <path
      d="M236.81 102.205C238.046 102.205 239.047 101.203 239.047 99.9678C239.047 98.7322 238.046 97.7305 236.81 97.7305C235.574 97.7305 234.573 98.7322 234.573 99.9678C234.573 101.203 235.574 102.205 236.81 102.205Z"
      fill="#E6E6E6"
    />
    <rect
      width="25"
      height="6"
      transform="translate(35.0652 18.2109)"
      fill="#E7E7E7"
    />
    <rect
      width="24"
      height="6"
      transform="translate(60.0652 18.2109)"
      fill="#D3D3D3"
    />
    <rect
      width="118"
      height="6"
      transform="translate(84.0652 18.2109)"
      fill="#B3B3B3"
    />
    <rect
      width="26"
      height="6"
      transform="translate(202.065 18.2109)"
      fill="#E7E7E7"
    />
    <rect
      width="82"
      height="6"
      transform="translate(35.0652 38.2109)"
      fill="#E7E7E7"
    />
    <rect
      width="48"
      height="6"
      transform="translate(117.065 38.2109)"
      fill="#D3D3D3"
    />
    <rect
      width="37"
      height="6"
      transform="translate(165.065 38.2109)"
      fill="#B3B3B3"
    />
    <rect
      width="26"
      height="6"
      transform="translate(202.065 38.2109)"
      fill="#E7E7E7"
    />
    <rect
      width="25"
      height="6"
      transform="translate(35.0652 58.2109)"
      fill="#E7E7E7"
    />
    <rect
      width="82"
      height="6"
      transform="translate(60.0652 58.2109)"
      fill="#D3D3D3"
    />
    <rect
      width="59"
      height="6"
      transform="translate(142.065 58.2109)"
      fill="#B3B3B3"
    />
    <rect
      width="26"
      height="6"
      transform="translate(201.065 58.2109)"
      fill="#E7E7E7"
    />
    <rect
      width="25"
      height="6"
      transform="translate(35.0652 78.2109)"
      fill="#E7E7E7"
    />
    <rect
      width="59"
      height="6"
      transform="translate(60.0652 78.2109)"
      fill="#B3B3B3"
    />
    <rect
      width="82"
      height="6"
      transform="translate(119.065 78.2109)"
      fill="#D3D3D3"
    />
    <rect
      width="26"
      height="6"
      transform="translate(201.065 78.2109)"
      fill="#E7E7E7"
    />
  </svg>
);

export default BarGraphBlank;
